import React from 'react';
import PropTypes from 'prop-types';
import { LabelWrapper } from './styles';

const Label = ({
  label,
  color,
  size,
  weight,
  margin,
  withCursor,
  lineHeight,
  alignSelf,
  isTitleNarrowMedium,
  textAlign,
  disableLink,
}) => (
  <LabelWrapper
    withCursor={withCursor}
    color={color}
    size={size}
    weight={weight}
    margin={margin}
    lineHeight={lineHeight}
    alignSelf={alignSelf}
    isTitleNarrowMedium={isTitleNarrowMedium}
    textAlign={textAlign}
    disableLink={disableLink}
  >
    {label}
  </LabelWrapper>
);

Label.propTypes = {
  label: PropTypes.any,
  color: PropTypes.string,
  size: PropTypes.number,
  weight: PropTypes.string,
  margin: PropTypes.any,
  withCursor: PropTypes.bool,
  lineHeight: PropTypes.number,
  alignSelf: PropTypes.string,
  isTitleNarrowMedium: PropTypes.bool,
  textAlign: PropTypes.string,
  disableLink: PropTypes.bool,
};


export default Label;
